import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";

import React, { useEffect, useState } from "react";

import MenuIcon from "@mui/icons-material/Menu";
import { P, SectionFooterHeading, SectionWrapper } from "../../../styles";

import logodark from "../../../images/logodark.png";
import TikTokB from "../../../images/TikTokB.png";
import InstagramB from "../../../images/InstagramB.png";
import TwitterB from "../../../images/TwitterB.png";
import FacebookB from "../../../images/FacebookB.png";
import imdbmob from "../../../images/imdbmob.png";
import { BASEURL } from "../../../configure";

const SocialsDiv = styled.div`
  display: grid;
  padding: 30px 0 20px 0;
  text-align: left;
`;
const SocialLinks = styled.a`
  color: #0a0a0a;
  font-family: "Poppins-SemiBold";
  text-decoration: none;
  &.a{
    padding-left: 15px;
    &::before{
      content: '>';
      padding-right: 5px;
    }
  }
  &.b{
    padding-left: 30px;
    &::before{
      content: '>';
      padding-right: 5px;
    }
  }
  &.c{
    padding-left: 45px;
    &::before{
      content: '>';
      padding-right: 5px;
    }
  }
`;
const GridBorder = styled(Grid)`
  border-bottom: 1px solid #0a0a0a;
  border-top: 1px solid #0a0a0a;
  align-items: CENTER;
  padding: 10px 0;
  @media screen and (max-width: 599px) {
    border-bottom: none;
    text-align-last: center;
  }
`;
const GridDesktop = styled(Grid)`
  @media screen and (max-width: 599px) {
    display: none;
  }
`;
const SocialMedia = styled.div`
  display: none;

  @media screen and (max-width: 599px) {
    display: flex;
    text-align: center;
    text-align-last: center;
    justify-content: center;
  }
`;
const SocialLinksMob = styled.a`
  place-content: center;
  padding: 0 10px;
`;
const DarkLogo = styled.img`
  width: 100%;
  height: auto;
  max-width: 210px;
`;
const SocialMediaMob = styled.img`
  width: 100%;
  height: auto;
  max-width: 22px;
`;

const Index = () => {
  const [ getMenu, setMenu ] = useState('');
  const [ getTiktok, setTiktok ] = useState('');
  const [ getInsta, setInsta ] = useState('');
  const [ getTwitter, setTwitter ] = useState('');
  const [ getFacebook, setFacebook ] = useState('');
  const [ getImdb, setImdb ] = useState('');
  
  useEffect(()=>{
      fetch(BASEURL+'social', {
        method: 'GET',
      }).then(response => response.json())
      .then( jsonData => {
        setTiktok(jsonData[0]?.tiktok)
        setInsta(jsonData[0]?.insta)
        setTwitter(jsonData[0]?.twitter)
        setFacebook(jsonData[0]?.facebook)
        setImdb(jsonData[0]?.imdb)
      }) 

      // fetch(BASEURL+'footer-menu', {
      //   method: 'GET',
      // }).then(response => response.json())
      // .then( jsonData => {
      //   const dataArr = [];
        
      //   console.log('menu Aray: ', jsonData)
      //   let pId = '', pTitle = '', pURL = '' 

      //   jsonData.map((keyA, indexA)=>{

      //     console.log('P1: ', keyA.title)

      //     keyA.child.map((keyB, indexB)=>{

      //       console.log('PB: ', keyB.title)
      //       // if (keyB?.child?.lenght <= 0 ) {
              
      //       // }else{
      //       //   keyB?.child.map((keyC, indexC)=>{

      //       //     console.log('PC: ', keyC)
  
      //       //   })
      //       // }
            

      //     })
      //   }
      //   // setMenu(jsonData.map((key, index)=>{

          
      //   // })
      //   )
      // }) 
  },[getTiktok, getTwitter, getImdb])
  return (
    <div>
      <SectionWrapper p599="1px 0" p="1px 0 ">
        <Container maxWidth="xl">
          <GridBorder container justifyContent='flex-start'>
            <Grid xs={12} md={5} sm={6} style={{textAlign:'left'}} data-aos="fade-up" data-aos-duration="400" data-aos-delay="400" data-aos-easing="ease-in" data-aos-offset="0" >
              <DarkLogo src={logodark} />
              {/* <P maxWidth="70%" align599="center">
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua.{" "}
              </P> */}
            </Grid>
            <Grid xs={12} md={5} sm={4} data-aos="fade-up" data-aos-duration="500" data-aos-delay="500" data-aos-easing="ease-in" data-aos-offset="0" >
              {/* <SectionFooterHeading>Quick links</SectionFooterHeading> */}
              <SocialsDiv>
                {/* {getMenu} */}
                <SocialLinks href="">Home</SocialLinks>
                <SocialLinks href="/#ourproject">Our Projects</SocialLinks>
                <SocialLinks href="/#aboutus">About us</SocialLinks>
                <SocialLinks href="/#team">Team</SocialLinks>
                <SocialLinks href="/#contactus">Contact us</SocialLinks>
              </SocialsDiv>
            </Grid>
            <GridDesktop xs={12} md={2} sm={2} data-aos="fade-up" data-aos-duration="600" data-aos-delay="600" data-aos-easing="ease-in" data-aos-offset="0" >
              {/* <SectionFooterHeading>Socials</SectionFooterHeading> */}
              <SocialsDiv>
                { getTiktok? <SocialLinks href={getTiktok? getTiktok: `#`} target="_blank">TikTok</SocialLinks>: null}
                { getInsta? <SocialLinks href={getInsta? getInsta: `#`} target="_blank">Instagram</SocialLinks>: null}
                { getTwitter? <SocialLinks href={getTwitter? getTwitter: `#`} target="_blank">Twitter</SocialLinks>: null}
                { getFacebook? <SocialLinks href={getFacebook? getFacebook: `#`} target="_blank">Facebook</SocialLinks>: null}
                { getImdb? <SocialLinks href={getImdb? getImdb: `#`} target="_blank">IMDb</SocialLinks>: null}
              </SocialsDiv>
            </GridDesktop>
          </GridBorder>
          <SocialMedia data-aos="fade-up" data-aos-duration="400" data-aos-delay="400" data-aos-easing="ease-in" data-aos-offset="0" > 
            { getTiktok?  <SocialLinksMob href={getTiktok? getTiktok: `#`} target="_blank"><SocialMediaMob src={TikTokB} /></SocialLinksMob>: null}
            { getInsta?  <SocialLinksMob href={getInsta? getInsta: `#`} target="_blank"><SocialMediaMob src={InstagramB} /> </SocialLinksMob>: null}
            { getTwitter?  <SocialLinksMob href={getTwitter? getTwitter: `#`} target="_blank"><SocialMediaMob src={TwitterB} /></SocialLinksMob>: null}
            { getFacebook?  <SocialLinksMob href={getFacebook? getFacebook: `#`} target="_blank"><SocialMediaMob src={FacebookB} /></SocialLinksMob>: null}
            { getImdb? <SocialLinksMob href={getImdb? getImdb: `#`} target="_blank"><SocialMediaMob src={imdbmob} /></SocialLinksMob>: null}
           
          </SocialMedia>
          <P tal="center" padding="10px  0 0 0" fs599="14px" align="center">
            Copyright © 2023 Primary Source Media
          </P>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default Index;
